<script setup>
import ArrowSquareOutIcon from '@iconify-vue/ph/arrow-square-out';
import XCircleIcon from '@iconify-vue/ph/x-circle-fill';
import { Link } from '@inertiajs/vue3';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const {
    tenant,
    objectiveName,
    achievedAt,
    lastAchievedAt,
    canBeToggle = true,
    callback,
    href = null,
} = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    objectiveName: {
        type: String,
        required: true,
    },
    achievedAt: {
        type: String,
        default: null,
    },
    lastAchievedAt: {
        type: String,
        default: null,
    },
    canBeToggle: {
        type: Boolean,
        default: true,
    },
    callback: {
        type: Function,
        required: false,
    },
    href: {
        type: String,
        required: false,
    },
});

const { route } = useRoute();

const enabled = ref(!!achievedAt);

function toggleAction() {
    enabled.value = !enabled.value;

    let url = route('front.projectManagement.task.postToggleObjective', {
        tenant: tenant.id,
    });

    axios
        .post(url, {
            objectiveName: objectiveName,
        })
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            enabled.value = !enabled.value;
            console.error(error);
        });
}
</script>

<template>
    <BaseCell>
        <div class="flex flex-col items-center gap-1">
            <button
                v-if="canBeToggle"
                type="button"
                :class="enabled ? 'bg-green-500' : 'bg-red-500'"
                class="relative inline-flex h-6 w-11 items-center rounded-full"
                @click="toggleAction"
            >
                <span
                    :class="enabled ? 'translate-x-6' : 'translate-x-1'"
                    class="inline-block size-4 transform rounded-full bg-white transition"
                />
            </button>

            <XCircleIcon v-else-if="!achievedAt" class="size-4 text-red-500" />

            <div
                v-if="enabled && achievedAt"
                class="text-xs font-bold whitespace-nowrap text-green-500"
            >
                {{ achievedAt }}
            </div>

            <div
                v-else-if="!enabled && lastAchievedAt"
                class="text-xs font-bold whitespace-nowrap text-red-500"
            >
                {{ lastAchievedAt }}
            </div>
        </div>

        <Link v-if="href" :href="href" class="text-blue-500">
            <ArrowSquareOutIcon class="size-4" />
        </Link>
    </BaseCell>
</template>
